import type { Theme } from '@mui/material/styles'

/**
 * Färger för staplad TÅ-graf: TÅ, TÅ utan rätter, därefter garantinivåer 1–5.
 * Ersätt med exakta värden från @osc-FL (Slack) när de finns.
 */
export function getCommitChartStackColors(theme: Theme): string[] {
    const { info } = theme.palette
    return [
        info.main,
        info.light,
        info[200] as string,
        info[300] as string,
        info[400] as string,
        info[500] as string,
        info[700] as string,
        info[900] as string,
        info[1000] as string,
    ]
}
